import React, {useEffect, useState} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import StripeCheckout from 'react-stripe-checkout';

function TourBooking() {
    // const [lodgings, setLodgings] = useState([]);
    const [tours, setTours ] = useState([]);
   
    useEffect(() => {
        fetch('https://us-central1-unieros-react.cloudfunctions.net/api/tours')
        .then(response => response.json())
        .then(data => setTours(data))
        .catch(error => console.error('Error: ', error));

        fetch('https://us-central1-unieros-react.cloudfunctions.net/api/tours')
        .then(response => response.json())
        .then(data => setTours(data))
        .catch(error => console.error('Error:', error));
    }, []);

    return (
        <div className="col-sm-12 mb-8">
            {tours.map((tour, index) => (
                <div key={index}>
                    
                    <h3 className="dislay-2">{tour.name}</h3>
                    <p> {tour.description}</p>

                   <span className="small">Daily activities subject to change based on time of year</span>
                   
          
        </div>
          ))}
       
         
          </div>
    );

}

export default TourBooking;